import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Select } from "antd"

const { Option } = Select

class SelectFilterOptions extends Component {
    render() {
        const { defaultValue, handleChange, listOptions, label, field, style, mode, showArrow, allowClear, placeholder, className, value, disabled, tokenSeparators, classNameLabel = '' } = this.props
        const hasValue = this.props.hasOwnProperty('value')

        return (
            <div className='SelectFilterOption'>
                {label && <label className={`font-weight-bold d-block ${!!classNameLabel ? classNameLabel : null}`}>{label}</label>}
                <Select
                    showSearch
                    className={className}
                    showArrow={showArrow}
                    allowClear={allowClear}
                    placeholder={placeholder}
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                        option.props.children.toString().toLowerCase().indexOf(input.toString().toLowerCase()) >= 0
                    }
                    mode={mode || 'default'}
                    defaultValue={defaultValue}
                    onChange={(value) => handleChange(field, value)}
                    style={style}
                    disabled={disabled}
                    tokenSeparators={tokenSeparators || false}
                    {...(!!hasValue && { value: value })}
                >
                    {
                        listOptions.map((item, index) =>
                            <Option key={index} value={item.value}>
                                {item.name}
                            </Option>
                        )
                    }
                </Select>
            </div>
        )
    }
}

SelectFilterOptions.defaultProps = {
    label: '',
    defaultValue: '',
    listOptions: []
}

SelectFilterOptions.propTypes = {
    // defaultValue: PropTypes.string,
    handleChange: PropTypes.func.isRequired,
    listOptions: PropTypes.array,
    field: PropTypes.string.isRequired,
    label: PropTypes.string
}

export default SelectFilterOptions